import { FC } from 'react'
import { Breadcrumb, Row, Text } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, header_image, header_image_text }) => {
  const directions = [{ dir: 'column', mq: 'sm' }]

  return (
    <S.FeaturedStyles imageUrl={header_image.url}>
      <Row directions={directions}>
        <S.BreadcrumbStyles>
          <Breadcrumb pages={breadcrumb} inverse={true} />
        </S.BreadcrumbStyles>
        <S.TextWrapper>
          <Text size='xxlg' weight='semiBlack' lineHeight='1.4'>
            <span dangerouslySetInnerHTML={{ __html: header_image_text.heading }} />
          </Text>

          <Text color='inverse' size='md' lineHeight='1.2'>
            {header_image_text.long_text}
          </Text>
        </S.TextWrapper>
        <S.TextAligner>
          <Text color='inverse' size='xs' weight='semiBlack' lineHeight='1.2'>
            {header_image_text.sub_heading}
          </Text>
        </S.TextAligner>
      </Row>
    </S.FeaturedStyles>
  )
}
